// src/constants/index.js
import defaultPlaceholder from '../assets/images/default_placeholder.svg';

export const ASSETS = {
  IMAGES: {
    DEFAULT_THUMBNAIL: '/assets/images/default_thumb.png',
    PLACEHOLDER: defaultPlaceholder
  }
};

export const PLUGIN_TYPES = {
  WEB: 'WEB',
  LINK: 'LINK'
};

export const API = {
  // Remove BASE_URL or set to empty string for relative URLs
  BASE_URL: '',  // Changed this line
  VERSION: process.env.REACT_APP_API_VERSION || '/be/api/v1',
  ENDPOINTS: {
    PLUGINS: '/plugins',
    THUMBNAILS: '/plugins/thumbnail'
  }
};

export const DEFAULT_VALUES = {
  BRANCH: {
    MAIN: 'main',
    BETA: 'beta'
  },
  DISPLAY_ORDER: 0
};